import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";

export default function Header() {
  const [startIndex, setStartIndex] = useState(0);

  // State to track which button is active
  const [activeButton, setActiveButton] = useState<"next" | "previous" | null>(
    null
  );

  // Total number of divs
  const totalDivs = 11;

  // How many divs to show at a time
  const visibleCount = 7;

  // Array of div content (manually defining unique content for each div)
  const divs = [
    { id: 1, content: "Smart Phone" },
    { id: 2, content: "Tabs & Laptops" },
    { id: 3, content: "Camera" },
    { id: 4, content: "Music System" },
    { id: 5, content: "MP3 Player" },
    { id: 6, content: "DVD Player" },
    { id: 7, content: "Consumer Appliance" },
    { id: 8, content: "Washing Machine" },
    { id: 9, content: "Refrigerators" },
    { id: 10, content: "Cooking System" },
    { id: 11, content: "Air Conditioner" },
  ];

  // Handle the "greater than" button click
  const handleNext = () => {
    setActiveButton("next"); // Set active button to "next"
    if (startIndex + visibleCount < totalDivs) {
      setStartIndex(startIndex + 1);
    }
    setTimeout(() => setActiveButton(null), 300);
  };

  // Handle the "less than" button click
  const handlePrevious = () => {
    setActiveButton("previous"); // Set active button to "previous"
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
    // Reset active button state after the animation
    setTimeout(() => setActiveButton(null), 300);
  };


  return (
    <section className="head2 d-none"  style={{ paddingTop: "90px" }}>
      <Container>
        {/* <div className="d-flex justify-content-between align-items-center"> */}
          {/* Less Than Button */}
          {/* <div className="less-div">
            <button
              className={`less ${activeButton === "previous" ? "active" : ""}`}
              onClick={handlePrevious}
              disabled={startIndex === 0}
            >
              <IoIosArrowForward />
            </button>
          </div> */}

          {/* Display only the visible divs */}
          <div className="d-flex justify-content-around align-items-center">
            {/* {divs.slice(startIndex, startIndex + visibleCount).map((div) => (
              <div key={div.id} className="custom-div">
                <p>{div.content}</p>
              </div>
            ))} */}

            <Link to="product/smart-phone" style={{textDecoration:"none",cursor:"pointer",color:"#000"}}>Smart Phone</Link>
            <Link to="/product/watch" style={{textDecoration:"none",cursor:"pointer",color:"#000"}}>Smart Watch</Link>
            <Link to="product/tab" style={{textDecoration:"none",cursor:"pointer",color:"#000"}}>Tab</Link>
          </div>

          {/* Greater Than Button */}
          {/* <div className="greater-div">
            <button
              className={`greater ${activeButton === "next" ? "active" : ""}`}
              onClick={handleNext}
              disabled={startIndex + visibleCount >= totalDivs}
            >
              <IoIosArrowForward />
            </button>
          </div> */}
        {/* </div> */}
      </Container>
    </section>
  );
}
